import {BaseConfig} from "../../infrastructure/config/base-config";
import {BoxScoresWidgetTerms} from "./box-scores-widget.terms";

export class BoxScoresWidgetConfig extends BaseConfig {
  tableCellWidthDesktop: Number;

  static injectables = [BoxScoresWidgetTerms];

  constructor(terms: BoxScoresWidgetTerms) {
    super('boxScoresWidget', null, terms);

    this.tableCellWidthDesktop = 38;
  }
}
